import { Stack, Typography } from "@mui/material";
import { stageLabel } from "../../../utils/stages";
import { useLang } from "../i18n";

export default function DeploymentSummary({ selection }) {
  const { t } = useLang();
  if (!selection) return null;
  // Pakettransport (v27): je Stufe „ganzes Paket an/aus" statt Artefaktzählung.
  if (selection.package) {
    const pkg = selection.package;
    const edgeCount = Object.values(selection.manualEdgeArtifacts || {}).flatMap(Object.values).filter(Boolean).length
      + Object.values(selection.designArtifacts || {}).filter(entry => entry?.manualEdgeDeployment).length;
    return <Stack spacing={0.5}>{Object.entries(pkg.stages || { default: pkg.deploy }).map(([stage, deploy]) => {
      const on = typeof deploy === "boolean" ? deploy : !!deploy;
      return <Typography key={stage} variant="body2" sx={{ color: "var(--t2)" }}>
        {stage !== "default" && <>{stageLabel(stage)}: </>}{t(on ? "pkgT.deploySummaryOn" : "pkgT.deploySummaryOff")}
        {edgeCount > 0 && <> · {t("deploy.edgeSummary", { count: edgeCount })}</>}
      </Typography>;
    })}</Stack>;
  }
  return <Stack spacing={0.5}>{Object.entries(selection.stages || { default: selection }).map(([stage, plan]) => {
    const ci = Object.values(plan.artifacts).flatMap(Object.values);
    const edge = Object.values(plan.manualEdgeArtifacts || {}).flatMap(Object.values).filter(Boolean).length;
    return <Typography key={stage} variant="body2" sx={{ color: "var(--t2)" }}>
      {stage !== "default" && <>{stageLabel(stage)}: </>}{t("deploy.summary", { on: ci.filter(Boolean).length, off: ci.filter(value => !value).length })}
      {edge > 0 && <> · {t("deploy.edgeSummary", { count: edge })}</>}
    </Typography>;
  })}</Stack>;
}
